import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=40995a33&scoped=true&"
import script from "./Advertising.vue?vue&type=script&lang=js&"
export * from "./Advertising.vue?vue&type=script&lang=js&"
import style0 from "./Advertising.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Advertising.vue?vue&type=style&index=1&id=40995a33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40995a33",
  null
  
)

export default component.exports